// This given key is public
// https://stackoverflow.com/questions/37482366/is-it-safe-to-expose-firebase-apikey-to-the-public
// In order to secure it, please refer to
// https://stackoverflow.com/questions/35418143/how-to-restrict-firebase-data-modification

export const firebaseConfig = {
   apiKey: 'AIzaSyC7UY52Ta47PlEEd4nGit8kpEsDJmllAD0',
   authDomain: 'battery-power-9a1d9.firebaseapp.com',
   databaseURL: 'https://battery-power-9a1d9.firebaseio.com',
   projectId: 'battery-power-9a1d9',
   storageBucket: 'battery-power-9a1d9.appspot.com',
   messagingSenderId: '43180403362',
   appId: '1:43180403362:web:a319c9a9a2766864fd05fb',
   measurementId: 'G-NZM6ER5V5E'
};

export default firebaseConfig;
